import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { AppStoreBadges } from "./AppStoreBadges";
import { LANDING } from "@/constants/testIds";

const LINK_COLS = [
  {
    title: "Product",
    links: [
      { label: "Home", to: "/" },
      { label: "Features", to: "/features" },
      { label: "Pricing", to: "/pricing" },
      { label: "About", to: "/about" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Support", to: "/support" },
      { label: "Contact", to: "/contact" },
      { label: "Help Center", to: "/support" },
      { label: "FAQ", to: "/support#faq" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy-policy", testId: LANDING.footerPrivacy },
      { label: "Terms of Service", to: "/terms-of-service", testId: LANDING.footerTerms },
      { label: "Account Deletion", to: "/account-deletion", testId: LANDING.footerAccountDeletion },
      { label: "Contact", to: "/contact", testId: LANDING.footerContact },
    ],
  },
];

export const Footer = () => {
  return (
    <footer
      data-testid={LANDING.footer}
      className="bg-[#F7FAF9] border-t border-[#0E6B6B]/10"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-12 py-16">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Logo />
            <p className="mt-5 text-[#4B5E5E] text-[15px] max-w-sm leading-relaxed">
              One connected operating record for independent retailers and growing multi-location teams—captured where work happens, understood wherever decisions are made.
            </p>
            <div className="mt-6">
              <AppStoreBadges
                playId="footer-google-play-cta"
                storeId="footer-app-store-cta"
                placement="footer"
              />
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {LINK_COLS.map((col) => (
              <div key={col.title}>
                <div className="text-xs uppercase tracking-[0.18em] font-bold text-[#D96C4A] mb-4">{col.title}</div>
                <ul className="space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label + l.to}>
                      <Link
                        to={l.to}
                        data-testid={l.testId || `footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                        className="text-sm text-[#1c2c2c] hover:text-[#0E6B6B] transition-colors"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#0E6B6B]/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="text-sm text-[#4B5E5E]">
            © {new Date().getFullYear()} Shopbook. Know what happened in your shop today. Know what to do next.
            <span className="ml-2 text-[#D96C4A]">Web workspace + companion mobile workflows.</span>
          </div>
          <div className="flex flex-wrap items-center gap-5 text-sm">
            <Link to="/support" data-testid={LANDING.footerSupport} className="text-[#1c2c2c] hover:text-[#0E6B6B]">Support</Link>
            <Link to="/privacy-policy" className="text-[#1c2c2c] hover:text-[#0E6B6B]">Privacy</Link>
            <Link to="/terms-of-service" className="text-[#1c2c2c] hover:text-[#0E6B6B]">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
